import { useUserStore } from '@/user/stores/userStore';

export const readCurrentWorkspace = () => {
  return useUserStore.getState().currentWorkspace;
};
